import type { Prototype } from "../prototype-types";

export const gabrielaTeranPrototypes: Prototype[] = [
  {
    id: "cancelled-order-view",
    name: "Cancelled Order View (Retailer)",
    path: "/gt/cancelled-order-view",
    description:
      "Retailer view of a cancelled order. Includes a new section showing cancellation reason and note from the brand — information not currently visible to retailers.",
    owner: "Gabriela Teran",
    createdAt: "2026-03-16",
    lastUpdated: "2026-03-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2994af3c56694ed566c9960b533180760a812f533edebfbd355a99c9c9be0c82.png",
    creationTool: "cursor",
  },
];
